import { forwardRef } from "react";
import Input from "@/atoms/Input";

const InputField = forwardRef(
  ({ label, required, desc, className, ...props }, ref) => {
    return (
      <div className={`awd-input-wrapper ${className}`}>
        <Input ref={ref} placeholder={label} {...props} />
        <label className="awd-input-label" htmlFor="name">
          {label}
          <span className="awd-input-required">{required && " *"}</span>
        </label>
        {desc && <span className="awd-input-desc">{desc}</span>}
      </div>
    );
  }
);

export default InputField;
